import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ActivityReview() {
  const [sp] = useSearchParams();
  const { t } = useTranslation();
  const rid = sp.get("rid");
  const token = sp.get("token");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (rating < 1) { toast.error(t("activities.rate")); return; }
    try {
      await api.post("/activity-reviews", { request_id: rid, token, rating, comment });
      setDone(true); toast.success(t("activities.reviewThanks"));
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };

  return (
    <div className="section-sand min-h-[70vh] flex items-center justify-center py-16 px-4">
      <div data-testid="activity-review-page" className="bg-white rounded-3xl shadow-card border border-border p-8 max-w-md w-full">
        {!rid || !token ? (
          <p className="text-center text-muted2 font-body">{t("activities.reviewInvalid")}</p>
        ) : done ? (
          <p data-testid="activity-review-done" className="text-center text-emeraude-dark font-bold py-6">{t("activities.reviewThanks")}</p>
        ) : (
          <>
            <h1 className="font-heading font-extrabold text-2xl text-ink text-center">{t("activities.reviewPageTitle")}</h1>
            <p className="text-muted2 font-body text-center mt-2 mb-5">{t("activities.reviewPageSub")}</p>
            <div className="flex justify-center gap-2 mb-4">
              {[1, 2, 3, 4, 5].map((s) => (
                <button key={s} data-testid={`review-star-${s}`} type="button" onClick={() => setRating(s)}>
                  <Star className={`w-9 h-9 ${s <= rating ? "fill-emeraude text-emeraude" : "text-border"}`} />
                </button>
              ))}
            </div>
            <textarea data-testid="review-comment" value={comment} onChange={(e) => setComment(e.target.value)} rows={3} placeholder={t("activities.reviewComment")} className="w-full rounded-xl bg-sand p-3 text-sm" />
            <Button data-testid="review-submit" onClick={submit} className="w-full mt-3 rounded-full bg-emeraude hover:bg-emeraude-dark font-bold h-11">{t("activities.submitReview")}</Button>
          </>
        )}
      </div>
    </div>
  );
}
